<template>
  <v-card
    :title="t('labels.distribution')"
    flat
    color="transparent"
    class="pa-4"
  >
    <template v-slot:text>
      <v-text-field
        v-model="searchDistribucion"
        :label="t('buttons.search')"
        prepend-inner-icon="mdi-magnify"
        variant="outlined"
        hide-details
        single-line
        density="compact"
        style="max-width: 400px"
      ></v-text-field>
    </template>

    <v-data-table
      :headers="headersDistribucion"
      :items="finalItemsDistri"
      :search="searchDistribucion"
      color="blue"
      hover
      @click:row="showDialog"
    >
      <template v-slot:item.latencia="{ value }">
        <v-row justify="center">
          <v-sheet width="60" color="transparent">
            <span>{{ value }}</span>
          </v-sheet>
          <v-sheet width="45%">
            <v-progress-linear
              bg-color="pink-lighten-3"
              :color="getLatencyColor(value)"
              model-value="100"
              height="15"
              style="border-radius: 10px"
            ></v-progress-linear>
          </v-sheet>
        </v-row>
      </template>
      <template v-slot:item.snr_v="{ value }">
        <v-row justify="center">
          <v-sheet width="60" color="transparent">
            <span>{{ value }}</span>
          </v-sheet>
          <v-sheet width="45%">
            <v-progress-linear
              bg-color="pink-lighten-3"
              :color="getSNRColor(value)"
              model-value="100"
              height="15"
              style="border-radius: 10px"
            ></v-progress-linear>
          </v-sheet>
        </v-row>
      </template>
      <template v-slot:item.snr_h="{ value }">
        <v-row justify="center">
          <v-sheet width="60" color="transparent">
            <span>{{ value }}</span>
          </v-sheet>
          <v-sheet width="45%" color="transparent">
            <v-progress-linear
              bg-color="pink-lighten-3"
              :color="getSNRColor(value)"
              model-value="100"
              height="15"
              style="border-radius: 10px"
            ></v-progress-linear>
          </v-sheet>
        </v-row>
      </template>
      <template v-slot:item.rxh="{ value }">
        <v-row justify="center">
          <v-sheet width="60" color="transparent">
            <span>{{ value }}</span>
          </v-sheet>
          <v-sheet width="45%" color="transparent">
            <v-progress-linear
              bg-color="pink-lighten-3"
              :color="getRXColor(value)"
              model-value="100"
              height="15"
              style="border-radius: 10px"
            ></v-progress-linear>
          </v-sheet>
        </v-row>
      </template>
      <template v-slot:item.rxv="{ value }">
        <v-row justify="center">
          <v-sheet width="60" color="transparent">
            <span>{{ value }}</span>
          </v-sheet>
          <v-sheet width="45%" color="transparent">
            <v-progress-linear
              bg-color="pink-lighten-3"
              :color="getRXColor(value)"
              model-value="100"
              height="15"
              style="border-radius: 10px"
            ></v-progress-linear>
          </v-sheet>
        </v-row>
      </template>
    </v-data-table>
  </v-card>

  <v-card :title="t('labels.access')" flat color="transparent" class="pa-4">
    <template v-slot:text>
      <v-text-field
        v-model="searchAcceso"
        :label="t('buttons.search')"
        prepend-inner-icon="mdi-magnify"
        variant="outlined"
        hide-details
        single-line
        density="compact"
        style="max-width: 400px"
      ></v-text-field>
    </template>

    <v-data-table
      :headers="headers"
      :items="finalItemsAcceso"
      :search="searchAcceso"
      color="blue"
      hover
      @click:row="showDialog"
    >
      <template v-slot:item.temperatura="{ value }">
        <v-row justify="center">
          <v-sheet width="60" color="transparent">
            <span>{{ value }} °C</span>
          </v-sheet>
          <v-sheet width="45%">
            <v-progress-linear
              bg-color="pink-lighten-3"
              :color="getTemperatureColor(value)"
              model-value="100"
              height="15"
              style="border-radius: 10px"
            ></v-progress-linear>
          </v-sheet>
        </v-row>
      </template>
      <template v-slot:item.voltaje="{ value }">
        <v-row justify="center">
          <v-sheet width="60" color="transparent">
            <span>{{ value }} V</span>
          </v-sheet>
          <v-sheet width="45%" color="transparent">
            <v-progress-linear
              bg-color="pink-lighten-3"
              :color="getVoltajeColor(value)"
              model-value="100"
              height="15"
              style="border-radius: 10px"
            ></v-progress-linear>
          </v-sheet>
        </v-row>
      </template>
      <template v-slot:item.cost="{ value }">
        <v-row justify="center">
          <v-sheet width="60" color="transparent">
            <span>{{ value }} </span>
          </v-sheet>
          <v-sheet width="45%" color="transparent">
            <v-progress-linear
              bg-color="pink-lighten-3"
              :color="getCostColor(value)"
              model-value="100"
              height="15"
              style="border-radius: 10px"
            ></v-progress-linear>
          </v-sheet>
        </v-row>
      </template>
      <template v-slot:item.latencia="{ value }">
        <v-row justify="center">
          <v-sheet width="60" color="transparent">
            <span>{{ value }}</span>
          </v-sheet>
          <v-sheet width="45%" color="transparent">
            <v-progress-linear
              bg-color="pink-lighten-3"
              :color="getLatencyColor(value)"
              model-value="100"
              height="15"
              style="border-radius: 10px"
            ></v-progress-linear>
          </v-sheet>
        </v-row>
      </template>
    </v-data-table>
  </v-card>

  <v-card :title="t('labels.client')" flat color="transparent" class="pa-4">
    <template v-slot:text>
      <v-text-field
        v-model="searchClient"
        :label="t('buttons.search')"
        prepend-inner-icon="mdi-magnify"
        variant="outlined"
        hide-details
        single-line
        density="compact"
        style="max-width: 400px"
      >
      </v-text-field>
    </template>

    <v-data-table
      :headers="headers"
      :items="finalItemsClient"
      :search="searchClient"
      color="blue"
      hover
      @click:row="showDialog"
    >
      <template v-slot:item.temperatura="{ value }">
        <v-row justify="center">
          <v-sheet width="60" color="transparent">
            <span>{{ value }} °C</span>
          </v-sheet>
          <v-sheet width="45%">
            <v-progress-linear
              bg-color="pink-lighten-3"
              :color="getTemperatureColor(value)"
              model-value="100"
              height="15"
              style="border-radius: 10px"
            ></v-progress-linear>
          </v-sheet>
        </v-row>
      </template>

      <template v-slot:item.voltaje="{ value }">
        <v-row justify="center">
          <v-sheet width="60" color="transparent">
            <span>{{ value }} V</span>
          </v-sheet>
          <v-sheet width="45%" color="transparent">
            <v-progress-linear
              bg-color="pink-lighten-3"
              :color="getVoltajeColor(value)"
              model-value="100"
              height="15"
              style="border-radius: 10px"
            ></v-progress-linear>
          </v-sheet>
        </v-row>
      </template>

      <template v-slot:item.cost="{ value }">
        <v-row justify="center">
          <v-sheet width="60" color="transparent">
            <span>{{ value }} </span>
          </v-sheet>
          <v-sheet width="45%" color="transparent">
            <v-progress-linear
              bg-color="pink-lighten-3"
              :color="getCostColor(value)"
              model-value="100"
              height="15"
              style="border-radius: 10px"
            ></v-progress-linear>
          </v-sheet>
        </v-row>
      </template>
      <template v-slot:item.latencia="{ value }">
        <v-row justify="center">
          <v-sheet width="60" color="transparent">
            <span>{{ value }}</span>
          </v-sheet>
          <v-sheet width="45%" color="transparent">
            <v-progress-linear
              bg-color="pink-lighten-3"
              :color="getLatencyColor(value)"
              model-value="100"
              height="15"
              style="border-radius: 10px"
            ></v-progress-linear>
          </v-sheet>
        </v-row>
      </template>
    </v-data-table>
  </v-card>

  <!-- DIALOG COMPONENT -->
  <v-dialog v-model="dialog" width="85%">
    <DialogComponent
      v-if="dialog"
      :ip="selectedIp"
      :typeSel="selectedType"
      :name="selectedName"
      @dialog="closeDialog"
      :status="'Ok'"
    />
  </v-dialog>
</template>

<script setup lang="ts">
import { computed, onMounted, ref } from "vue";

/********************************
 ********** CONSTANTES **********
 *******************************/
import { LABELS } from "@/constants/labels";

/********************************
 *********** SERVICES ***********
 *******************************/
import {
  getAllLatencyData,
  getAllQualityData,
  getAllRajantData,
  getAllSensoresData,
} from "@/services/Smartlink/KPI";

/********************************
 ************ STORE *************
 *******************************/
import { useStore } from "vuex";
const store = useStore();

/********************************
 ************ I18N **************
 *******************************/
import { useI18n } from "vue-i18n";
const { t } = useI18n();

/********************************
 ********** COMPONENTES *********
 *******************************/
import DialogComponent from "@/components/SmartLink/dialog/dialogComponent.vue";
import { COLOR } from "@/constants/colors";

function getVoltajeColor(voltaje: number): string {
  if (voltaje < 5000 && voltaje > 0) {
    return COLOR.green;
  } else if (voltaje >= 5000 && voltaje < 10000) {
    return COLOR.yellow;
  } else if (voltaje >= 10000) {
    return COLOR.red;
  } else {
    return COLOR.grey;
  }
}

function getTemperatureColor(temperature: number): string {
  if (temperature <= 30) {
    return COLOR.green;
  } else if (temperature > 30 && temperature <= 60) {
    return COLOR.yellow;
  } else if (temperature > 60 && temperature <= 70) {
    return COLOR.warning;
  }else {
    return COLOR.red;
  }
}

function getCostColor(cost: number): string {
  if (cost < 5000) {
    return COLOR.green;
  } else if (cost >= 5000 && cost < 10000) {
    return COLOR.yellow;
  } else {
    return COLOR.red;
  }
}

function getLatencyColor(latency: number): string {
  if (latency < 100 && latency >= 0) {
    return COLOR.green;
  } else if (latency >= 100 && latency < 200) {
    return COLOR.yellow;
  } else if (latency >= 200) {
    return COLOR.red;
  } else {
    return COLOR.grey;
  }
}

function getSNRColor(snr: number): string {
  if (snr < 16 && snr >= 0) {
    return COLOR.red;
  } else if (snr >= 16 && snr < 20) {
    return COLOR.yellow;
  } else if (snr >= 20) {
    return COLOR.green;
  } else {
    return COLOR.grey;
  }
}

function getRXColor(rx: number): string {
  if (rx < 0 && rx >= -65) {
    return COLOR.green;
  } else if (rx >= -75 && rx < -65) {
    return COLOR.yellow;
  } else if (rx < -75) {
    return COLOR.red;
  } else {
    return COLOR.grey;
  }
}

const searchDistribucion = ref("");
const searchAcceso = ref("");
const searchClient = ref("");
const headers = computed(() => [
  { key: "name", title: t("labels.equipment"), sortable: true },
  { key: "ip", title: "IP", sortable: true },
  { key: "tipo", title: `${t("labels.type")}`, sortable: true },
  { key: "latencia", title: `${t("labels.latency")} (ms)`, sortable: true },
  { key: "cost", title: t("labels.cost"), sortable: true },
  {
    key: "temperatura",
    title: `${t("labels.temperature")} (°C)`,
    sortable: true,
  },
  { key: "voltaje", title: `${t("labels.voltage")} (Volt)`, sortable: true },
]);
const headersDistribucion = computed(() => [
  { key: "name", title: t("labels.equipment"), sortable: true },
  { key: "ip", title: "IP", sortable: true },
  { key: "tipo", title: `${t("labels.type")}`, sortable: true },
  { key: "latencia", title: `${t("labels.latency")} (ms)`, sortable: true },
  { key: "snr_v", title: `${t("labels.snrVerti")} (dB)`, sortable: true },
  { key: "snr_h", title: `${t("labels.snrHoriz")} (dB)`, sortable: true },
  { key: "rxh", title: `${t("labels.rxHoriz")} (dBm)`, sortable: true },
  { key: "rxv", title: `${t("labels.rxVerti")} (dBm)`, sortable: true },
]);

const latencyItems = ref<any[]>([]);
const costItems = ref<any[]>([]);
const sensoresItems = ref<any[]>([]);
const qualityItems = ref<any[]>([]);
const finalItemsDistri = ref<any[]>([]);
const finalItemsAcceso = ref<any[]>([]);
const finalItemsClient = ref<any[]>([]);

async function getDataLatencyTable() {
  const allData = await getAllLatencyData();

  if (allData.status === 400) {
    store.commit("showSnackBar", {
      type: LABELS.error,
      msg: t("snackbar.errorApis"),
      valor: true,
    });
  }
  if (allData.status === 200) {
    // showError.value = !allData.showGraphs
    latencyItems.value = allData.data;
  }
}

async function getDataCostTable() {
  const allData = await getAllRajantData();

  if (allData.status === 400) {
    store.commit("showSnackBar", {
      type: LABELS.error,
      msg: t("snackbar.errorApis"),
      valor: true,
    });
  }
  if (allData.status === 200) {
    // showError.value = !allData.showGraphs
    costItems.value = allData.data;
  }
}

async function getDataSensoresTable() {
  const allData = await getAllSensoresData();

  if (allData.status === 400) {
    store.commit("showSnackBar", {
      type: LABELS.error,
      msg: t("snackbar.errorApis"),
      valor: true,
    });
  }
  if (allData.status === 200) {
    // showError.value = !allData.showGraphs
    sensoresItems.value = allData.data;
  }
}

async function getDataQualityTable() {
  const allData = await getAllQualityData();

  if (allData.status === 400) {
    store.commit("showSnackBar", {
      type: LABELS.error,
      msg: t("snackbar.errorApis"),
      valor: true,
    });
  }
  if (allData.status === 200) {
    // showError.value = !allData.showGraphs
    qualityItems.value = allData.data;
  }
}

async function combineData() {
  latencyItems.value.forEach((item) => {
    const costItem = costItems.value[item.ip];
    const sensorItem = sensoresItems.value[item.ip];
    const qualityItem = qualityItems.value[item.ip];

    const modelo = JSON.parse(item.anotacion ?? '{"model": "-"}');

    const finalObj = {
      ip: item.ip,
      name: `${item.name} - ${modelo.model??'-'}`,
      tipo: item.tipo,
      latencia: item.latencia,
      cost: costItem ? costItem.cost : 0,
      temperatura: sensorItem ? sensorItem.temperatura : 0,
      voltaje: sensorItem ? sensorItem.voltaje : 0,
      snr_v: qualityItem ? qualityItem.snr_v : 0,
      snr_h: qualityItem ? qualityItem.snr_h : 0,
      avgpower: qualityItem ? qualityItem.avgpower : 0,
      rxh: qualityItem ? qualityItem.rxh : 0,
      rxv: qualityItem ? qualityItem.rxv : 0,
    };
    if (
      item.subtipo === "Distribución" ||
      item.subtipo === "Distribucion" ||
      item.subtipo === "Distribution"
    ) {
      finalItemsDistri.value.push(finalObj);
    }
    if (item.subtipo === "Acceso") {
      finalItemsAcceso.value.push(finalObj);
    }
    if (item.subtipo === "Cliente") {
      finalItemsClient.value.push(finalObj);
    }
  });
}

/**
 * Mostrar el Dialogo
 */
const dialog = ref(false);

/**
 * IP del equipo Seleccionado de la tabla para mostrar en el DIÁLOGO
 */
const selectedIp = ref("");

/**
 * Nombre del equipo Seleccionado de la tabla para mostrar en el DIÁLOGO
 */
const selectedName = ref("");

/**
 * Tipo del equipo Seleccionado de la tabla para mostrar en el DIÁLOGO
 */
const selectedType = ref("");

/**
 * Captura toda la información del elemento seleccionado en la tabla
 * y se almacenan los valores de (ip, tipo, nombre, marca, estado) en las variables correspondientes
 * para luego abrir el dialog con la información gráfica y estadística del equipo en cuestión
 * @param item La fila seleccionada en la tabla
 */
function showDialog(event: any, { item }: any) {
  console.log("ITEM CLICKED:", item);
  selectedIp.value = item.ip ?? "";
  selectedType.value = item.tipo ?? "";
  selectedName.value = item.name ?? "";
  dialog.value = true;
}

/**
 * Cierra el Diálogo mediante un EMIT del componente de Dialogo
 */
function closeDialog() {
  dialog.value = false;
}

onMounted(async () => {
  await getDataLatencyTable();
  await getDataCostTable();
  await getDataSensoresTable();
  await getDataQualityTable();
  await combineData();
});
</script>

<style>
.v-table {
  background-color: transparent !important;
}
</style>
